module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title\" [innerHTML]=\"title\"></h4>\n</div>\n<div class=\"modal-body\"><p [innerHTML]=\"body\"></p></div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"activeModal.close('yes')\">\n        <i class=\"fas fa-check\"></i>\n        Yes\n    </button>\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"activeModal.dismiss('no')\">\n        <i class=\"fas fa-times\"></i>\n        No\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modals/confirmation.modal.html
// module id = 630
// module chunks = 1